export const CommonDataActionConst = {
    GET_COMMON_MASTER_DATA_REQ: "GET_COMMON_MASTER_DATA_REQ",
    GET_COMMON_MASTER_DATA_SUCCESS: "GET_COMMON_MASTER_DATA_SUCCESS",
    GET_COMMON_MASTER_DATA_FAIL: "GET_COMMON_MASTER_DATA_FAIL",
}

export const ChangeMaintenenceStep = {
    CHANGE_MAINTENANCE_STEP: "CHANGE_MAINTENANCE_STEP",

}

export const GetCurrentActiveChatSession = {
    GET_ACTIVE_CHAT_SESSION_REQ: "GET_ACTIVE_CHAT_SESSION_REQ",
    GET_ACTIVE_CHAT_SESSION_SUCC: "GET_ACTIVE_CHAT_SESSION_SUCC",
    GET_ACTIVE_CHAT_SESSION_FAIL: "GET_ACTIVE_CHAT_SESSION_FAIL",


}